export function getTikTokPlayerUrl(sourceUrl: string): string | undefined {
	try {
		const url = new URL(sourceUrl);
		if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;

		const hostname = url.hostname.toLowerCase();
		if (hostname !== 'tiktok.com' && !hostname.endsWith('.tiktok.com')) return undefined;

		const videoId = /^\/@[\w.-]+\/video\/(\d+)\/?$/.exec(url.pathname)?.[1];
		if (!videoId) return undefined;

		const options = new URLSearchParams({
			autoplay: '0',
			controls: '1',
			description: '0',
			loop: '1',
			music_info: '0',
			rel: '0',
		});
		return `https://www.tiktok.com/player/v1/${videoId}?${options.toString()}`;
	} catch {
		return undefined;
	}
}
